if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      static outsideListenerAttached = false;

      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          searchInput: this.querySelector('.disclosure__search-input'),
          listItems: this.querySelectorAll('.disclosure__item'),
        };
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
        
        // Initialize search functionality
        if (this.elements.searchInput) {
          this.elements.searchInput.addEventListener('input', this.onSearchInput.bind(this));
          this.elements.searchInput.addEventListener('keydown', this.onSearchKeydown.bind(this));
        }
      }

      connectedCallback() {
        if (!LocalizationForm.outsideListenerAttached) {
          LocalizationForm.outsideListenerAttached = true;
          document.addEventListener('pointerdown', LocalizationForm.handleOutsidePointer, true);
        }
      }

      static handleOutsidePointer(event) {
        document.querySelectorAll('localization-form').forEach((form) => {
          const panel = form.querySelector('.disclosure__list-wrapper');
          if (!panel || panel.hasAttribute('hidden')) return;
          if (form.contains(event.target)) return;

          form.hidePanel();
        });
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
        this.classList.remove('localization-form--open');
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
        this.hidePanel();
        event.stopPropagation();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      openSelector() {
        document.querySelectorAll('localization-form').forEach((form) => {
          if (form === this) return;

          const panel = form.querySelector('.disclosure__list-wrapper');
          const button = form.querySelector('.disclosure__button');

          if (!panel || panel.hasAttribute('hidden')) return;

          panel.setAttribute('hidden', true);
          button?.setAttribute('aria-expanded', 'false');
          form.classList.remove('localization-form--open');
        });

        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        const isOpen = !this.elements.panel.hasAttribute('hidden');
        this.classList.toggle('localization-form--open', isOpen);
        this.elements.button.setAttribute(
          'aria-expanded',
          isOpen.toString()
        );
        
        // Focus search input when panel opens
        if (this.elements.searchInput && !this.elements.panel.hasAttribute('hidden')) {
          setTimeout(() => {
            this.elements.searchInput.focus();
            this.elements.searchInput.select();
          }, 100);
        }
      }

      closeSelector(event) {
        const isChild =
          this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
        if (!event.relatedTarget || !isChild) {
          this.hidePanel();
        }
      }

      onSearchInput(event) {
        const searchTerm = event.target.value.toLowerCase().trim();
        
        this.elements.listItems.forEach((item) => {
          const countryName = item.dataset.countryName || '';
          const currencyCode = item.dataset.currencyCode || '';
          
          if (countryName.includes(searchTerm) || currencyCode.includes(searchTerm)) {
            item.classList.remove('hidden');
          } else {
            item.classList.add('hidden');
          }
        });
      }

      onSearchKeydown(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.elements.searchInput.value = '';
          this.onSearchInput({ target: { value: '' } });
          this.elements.button.focus();
        }
      }
    }
  );
}
